import {
  WS_FRIDAY,
  WS_MONDAY,
  WS_SATURDAY,
  WS_SUNDAY,
  WS_THURSDAY,
  WS_TUESDAY,
  WS_WEDNESDAY,
} from '@pages/WorkSchedule/constants/filters';

export const days = [
  {
    id: 0,
    title: 'пн',
    humanId: WS_MONDAY,
  },
  {
    id: 1,
    title: 'вт',
    humanId: WS_TUESDAY,
  },
  {
    id: 2,
    title: 'ср',
    humanId: WS_WEDNESDAY,
  },
  {
    id: 3,
    title: 'чт',
    humanId: WS_THURSDAY,
  },
  {
    id: 4,
    title: 'пт',
    humanId: WS_FRIDAY,
  },
  {
    id: 5,
    title: 'сб',
    humanId: WS_SATURDAY,
    isWeekend: true,
  },
  {
    id: 6,
    title: 'вс',
    humanId: WS_SUNDAY,
    isWeekend: true,
  },
];
